import React from 'react';
import { useSearchParams } from 'react-router-dom';
import OnuManagerPanel from '../../components/technical/OnuManagerPanel';
import useDarkReady from '../../theme/useDarkReady';

export default function TechnicalOnuListPage() {
  useDarkReady();
  const [searchParams] = useSearchParams();
  // Seeded from ?q= — the Dashboard's own ONU search hands off here when a query matches
  // more than one ONU instead of guessing which one was meant.
  return <OnuManagerPanel variant="page" seedQuery={searchParams.get('q') || ''} />;
}
